/**
 * Controller for the batch copy folders modal
 */
export default function batchCopyFoldersCtrl($scope, $uibModalInstance, $http, config, users, userInfo) {
  var ctrl = this
  
  // Initialize controller properties
  ctrl.users = users
  ctrl.sourceUser = users[0]
  ctrl.destinationUserUuid = ''
  ctrl.isLoading = false
  ctrl.error = null
  ctrl.success = null
  ctrl.hasFolders = userInfo.userInfo.toolkit_folders > 0
  ctrl.folderCount = userInfo.userInfo.toolkit_folders || 0
  ctrl.copyResults = null
  ctrl.resultDetails = []
  
  /**
   * Submit the batch copy request
   */
  ctrl.submit = function() {
    resetState()
    makeApiRequest()
  }
  
  /**
   * Reset the controller state before making a new request
   */
  function resetState() {
    ctrl.isLoading = true
    ctrl.error = null
    ctrl.success = null
    ctrl.copyResults = null
    ctrl.resultDetails = []
    ctrl.copiedCount = 0
    ctrl.errorCount = 0
    ctrl.successCount = 0
    ctrl.failureCount = 0
  }
  
  /**
   * Make the API request to batch copy folders
   */
  function makeApiRequest() {
    var requestData = {
      source_uuid: ctrl.sourceUser.uuid,
      dest_uuid: ctrl.destinationUserUuid
    }
    
    var apiUrl = config.apiEndPoint + '/batch_copy'
    $http.post(apiUrl, requestData)
      .then(handleSuccess, handleError)
  }
  
  /**
   * Handle successful API response
   * @param {Object} response - The HTTP response object
   */
  function handleSuccess(response) {
    ctrl.isLoading = false
    ctrl.copyResults = response.data
    
    if (response.data.success) {
      ctrl.success = 'Successfully copied Toolkit folders from ' + 
        ctrl.sourceUser.name + ' to the destination user.'
      
      processResults(response.data.results)
    } else {
      handleApiError(response.data)
    }
  }
  
  /**
   * Process the results from the API response
   * @param {Object} results - The results object from the API response
   */
  function processResults(results) {
    if (!results) return
    
    // Find the appropriate result key
    var expectedKey = ctrl.sourceUser.uuid + '_' + ctrl.destinationUserUuid
    var resultKey = expectedKey
    
    // If our expected key isn't found, use the first available key
    var availableKeys = Object.keys(results)
    if (availableKeys.length > 0 && !results[expectedKey]) {
      resultKey = availableKeys[0]
    }
    
    if (results[resultKey]) {
      var folderResults = results[resultKey]
      
      if (folderResults.folders && Array.isArray(folderResults.folders)) {
        processNewFormatResults(folderResults)
      }
    }
  }
  
  /**
   * Process results in the new format (with folders array)
   * @param {Object} folderResults - The folder results object
   */
  function processNewFormatResults(folderResults) {
    // Process each folder in the array
    folderResults.folders.forEach(function(folder) {
      ctrl.resultDetails.push({
        name: folder.name || 'Unnamed folder',
        success: folder.status === 'success',
        message: folder.message || '',
        sourceId: folder.uuid || '',
        destId: folder.new_uuid || '',
        itemCount: 0 // This info isn't available in the new format
      })
    })
    
    // Set summary information
    ctrl.copiedCount = folderResults.copied_count || 0
    ctrl.errorCount = folderResults.error_count || 0
    
    // Calculate success and failure counts for the template
    updateSuccessFailureCounts()
  }
  
  /**
   * Update the success and failure counts based on result details
   */
  function updateSuccessFailureCounts() {
    ctrl.successCount = ctrl.resultDetails.filter(function(r) { return r.success; }).length
    ctrl.failureCount = ctrl.resultDetails.filter(function(r) { return !r.success; }).length
  }
  
  /**
   * Handle API error response
   * @param {Object} errorData - The error data from the API
   */
  function handleApiError(errorData) {
    ctrl.error = 'Error copying folders: ' + 
      (errorData.errors && errorData.errors.length > 0 ? 
        errorData.errors[0].error : 'Unknown error')
  }
  
  /**
   * Handle HTTP error response
   * @param {Object} error - The HTTP error object
   */
  function handleError(error) {
    ctrl.isLoading = false
    ctrl.error = 'Error copying folders: ' + 
      (error.data && error.data.message ? error.data.message : 'Unknown error')
  }
  
  /**
   * Close the modal
   */
  ctrl.close = function() {
    $uibModalInstance.close(ctrl.success !== null)
  }
  
  /**
   * Cancel the operation
   */
  ctrl.cancel = function() {
    $uibModalInstance.dismiss('cancel')
  }
}

batchCopyFoldersCtrl.$inject = ['$scope', '$uibModalInstance', '$http', 'configuration', 'users', 'userInfo']
